import { Badge, Divider, Group, JsonInput, ScrollArea, Stack, Tabs, Text, Title } from "@mantine/core";
import { DevelopmentSupportData } from "../types";

export interface SupportingContentProps {
    developmentSupportData?: DevelopmentSupportData;
}

export const SupportingContent = ({ developmentSupportData }: SupportingContentProps) => {
    if (developmentSupportData == null || developmentSupportData?.sources.length === 0) {
        return (
            <Stack gap="sm">
                <i>No sources yet</i>
            </Stack>
        );
    }
    return (
        <Stack gap="md">
            {developmentSupportData?.sources.map((item, index) => {
                return (
                    <Stack gap="sm" key={index} p="xs" bg="gray.1" styles={{ root: { borderRadius: "var(--mantine-radius-md)" } }}>
                        <Title order={5} mb="xs">
                            {item.title}
                        </Title>
                        <Tabs defaultValue="overview">
                            <Tabs.List>
                                <Tabs.Tab value="overview">Overview</Tabs.Tab>
                                <Tabs.Tab value="metadata">JSON</Tabs.Tab>
                            </Tabs.List>

                            <Tabs.Panel value="overview" pt="md">
                                <Stack gap="md">
                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            Title
                                        </Text>
                                        <Text size="sm">{item.title || "-"}</Text>
                                    </div>

                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            Source
                                        </Text>
                                        <Text size="sm">{item.dataSource || "-"}</Text>
                                    </div>

                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            Media Type
                                        </Text>
                                        <Text size="sm">{item.mediaType || "-"}</Text>
                                    </div>

                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            Reference Number
                                        </Text>
                                        <Text size="sm">
                                            {" "}
                                            <Badge variant="light">{item.referenceNumber || "-"}</Badge>
                                        </Text>
                                    </div>

                                    {item.interestAreas && item.interestAreas.length > 0 && (
                                        <div>
                                            <Text fw={500} size="sm" mb={4}>
                                                Interest Areas
                                            </Text>
                                            <Group gap="xs">
                                                {item.interestAreas.map((area, idx) => (
                                                    <Badge key={idx} variant="light" color="blue">
                                                        {area}
                                                    </Badge>
                                                ))}
                                            </Group>
                                        </div>
                                    )}

                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            Last Modified
                                        </Text>
                                        <Text size="sm">{item.lastModifiedOn ? item.lastModifiedOn : "-"}</Text>
                                    </div>

                                    <Divider />

                                    <div>
                                        <Text fw={500} size="sm" mb={4}>
                                            File Information
                                        </Text>
                                        <Stack gap="xs">
                                            <Text size="sm">
                                                <Text span fw={500}>
                                                    URL:
                                                </Text>{" "}
                                                {item.url}
                                            </Text>
                                            <Text size="sm">
                                                <Text span fw={500}>
                                                    Cloudinary ID:
                                                </Text>{" "}
                                                {item.cloudinaryId || "-"}
                                            </Text>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Tabs.Panel>

                            <Tabs.Panel value="metadata" pt="md">
                                <JsonInput
                                    value={JSON.stringify(item)}
                                    readOnly
                                    minRows={20}
                                    styles={{
                                        input: {
                                            fontFamily: "monospace",
                                            fontSize: "12px",
                                            height: "400px",
                                            overflow: "auto"
                                        }
                                    }}
                                />
                            </Tabs.Panel>
                        </Tabs>
                    </Stack>
                );
            })}
        </Stack>
    );
};
